import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import classes from './AdminDashboard.module.scss';
import Notification from 'grommet/components/Notification';
import ManageMembershipPlans from './ManageMembershipPlans/ManageMembershipPlans';
import ManageGym from './ManageGym/ManageGym';
import AddEditMembershipPlan from './ManageMembershipPlans/AddEditMembershipPlan/AddEditMembershipPlan';
import ManageClients from './ManageUsers/ManageClients/ManageClients';
import ManageTrainers from './ManageUsers/ManageTrainers/ManageTrainers';
import TrainersAddEditTrainer from './ManageUsers/ManageTrainers/TrainersAddEditTrainer/TrainersAddEditTrainer';
import ClientProfile from './ClientProfile/ClientProfile';
import AdminQrScanner from './AdminQrScanner/AdminQrScanner';
import Reports from './Reports';
import ClassPassesReport from './Reports/ClassPasses/ClassPassesReport';
import ClassAttendancesReports from './Reports/ClassAttendancesReports/ClassAttendancesReports';
import AttendancesReports from './Reports/AttendancesReports/AttendancesReports';
import DebtorsReports from './Reports/DebtorReports/DebtorReports';
import PayrollReports from './Reports/PayrollReports/PayrollReports';
import WhiteBackground from '../../hoc/WhiteBackground/WhiteBackground';
import ClassPage from '../ClassPage/ClassPage';
import ManageFAQ from '../FAQ/ManageFAQ';
import CombinedHistoryComponent from '../HistoryComponent/HistoryComponent';
import NeedsApproval from './NeedsApproval/NeedsApproval';
import KitList from '../../components/KitList/KitList';
import ManageAdmins from './ManageUsers/ManageAdmins/ManageAdmins';
import AddEditAdmin from './ManageUsers/ManageAdmins/AddEditAdmin/AddEditAdmin';
import LiveStreamBroadcaster from '../LiveStream/LiveStreamBroadcaster/LiveStreamBroadcaster';
import StaffCalendar from './StaffCalendar/StaffCalendar';
import withUser from '../../store/hoc/withUser';
import withAdminDashboard from '../../store/hoc/withAdminDashboard';
import ManageTimetable from '../Timetables/ManageTimetable/ManageTimetable';
import AdminTrainerSubHeader from '../../components/Navigation/AdminTrainerSubHeader/AdminTrainerSubHeader';
import { isFullAccessAdminOrTrainer } from '../../shared/userFunctions';
import TilesBoard from '../../components/UI/TilesBoard/TilesBoard';
import { menuItemsArray } from '../../components/Navigation/MenuNavigation/menuItems';
import TrainersUpcomingClasses from '../TrainersUpcomingClasses/TrainersUpcomingClasses';
import Loading from '../../components/Loading/Loading';
import BulkEditing from '../BulkEditing/BulkEditing';
import UpcomingClassesForAllGyms from '../Timetables/UpcomingClassesForAllGyms/UpcomingClassesForAllGyms';
import DatabaseSearches from './DatabaseSearches/DatabaseSearches';
import Viewer from '../ManageVideos/ShowVideos/Viewer/Viewer';
import { CLASS } from '../../constants';
import ManageCoupons from '../../containers/ManageCoupons/ManageCoupons';

const AdminTrainerDashboard = (props) => {
  const [isApiCalled, setIsApiCalled] = useState(false);
  const isBrandKE = process.env.REACT_APP_BRAND === 'KE' ? true : false;
  const massageLink = isBrandKE ? `${props.match.url}/dining-room-timetable` : `${props.match.url}/massage-timetable`;

  const gymLink = isBrandKE ? `${props.match.url}/gym-timetable-1` : `${props.match.url}/gym-timetable`;

  const gymLink2 = `${props.match.url}/gym-timetable-2`;

  const swimLink = isBrandKE ? `${props.match.url}/swim-timetable-1` : `${props.match.url}/swim-timetable`;

  const tennisLink = isBrandKE ? `${props.match.url}/swim-timetable-2` : `${props.match.url}/tennis-timetable`;

  useEffect(
    () => {
      props.onFetchLocations();
      props.onFetchGymUsersList(props.match.params.gymId);
      props.onFetchGymDetails(props.match.params.gymId);
      props.onFetchTrainersList(props.match.params.gymId);

      if (props.userData.role === 'admin') {
        if (isFullAccessAdminOrTrainer(props.userData)) {
          props.onFetchTrainersList('all');
        }
        props.onFetchPlansList(props.match.params.gymId);
        props.onFetchClassesTemplatesList(props.match.params.gymId);
      }
    }, // eslint-disable-next-line
    []
  );

  useEffect(() => {
    props.history.listen(() => {
      let thePath = props.history.location.pathname;
      let path = thePath.substring(thePath.lastIndexOf('/') + 1);
      if (path === 'admins' && props.userData.role === 'admin' && !isApiCalled) {
        setIsApiCalled(true);
        props.onFetchGymAdmins(props.match.params.gymId);
      }
    });
    // eslint-disable-next-line
  }, [props.history.location.pathname]);

  const renderGymDashboard = () => {
    if (!props.gymDataLoading && !props.gymDataError) {
      const tiles = menuItemsArray(
        props.userData,
        props.selectedGym.settings,
        props.match.url,
        props.locations,
        'showAsTile'
      );
      return (
        <>
          <Switch>
            <Route path={props.match.url} exact render={() => <TilesBoard tiles={tiles} />} />

            {/**DATABASE SEARCH**/}
            <Route path={`${props.match.url}/search`} component={DatabaseSearches} />

            {/**BULK MANAGEMENT ROUTES**/}
            <Route path={`${props.match.url}/bulk-management`} component={BulkEditing} />

            {/**MANAGE CLIENT ROUTES**/}
            <Route
              path={`${props.match.url}/clients`}
              exact
              render={() => (
                <ManageClients
                  allGymsClients={false}
                  isAdmin={props.userData.role === 'admin'}
                  error={props.gymUsersListError}
                  loading={props.gymUsersListLoading}
                  classPasses={props.classPasses}
                  personalTrainings={props.personalTrainings}
                  gymMemberships={props.plansList}
                  gymSettings={props.selectedGym.settings}
                  match={props.match}
                  history={props.history}
                />
              )}
            />

            <Route
              path={`${props.match.url}/clients/:clientId`}
              render={() => <ClientProfile key={document.location.href} />}
            />

            {/**MANAGE ADMINS ROUTES**/}
            <Route path={`${props.match.url}/admins`} exact component={ManageAdmins} />
            <Route path={`${props.match.url}/admins/add`} render={() => <AddEditAdmin editAdmin={false} />} />

            {/**MANAGE TRAINER ROUTES**/}
            <Route
              path={`${props.match.url}/trainers`}
              exact
              render={() => (
                <ManageTrainers
                  locations={props.locations}
                  userData={props.userData}
                  trainersList={props.trainersList}
                  refreshTrainersList={props.onFetchTrainersList}
                  error={props.trainersListError}
                  loading={props.trainersListLoading}
                  match={props.match}
                  history={props.history}
                />
              )}
            />
            <Route path={`${props.match.url}/trainers/add`} exact component={TrainersAddEditTrainer} />

            {/**GYM SETTINGS ROUTES**/}
            <Route path={`${props.match.url}/settings`} exact component={ManageGym} />
            <Route
              path={`${props.match.url}/needs-approval`}
              render={() => (
                <NeedsApproval match={props.match} history={props.history} isAdmin={props.userData.role === 'admin'} />
              )}
            />

            {/**REPORT ROUTES**/}
            <Route path={`${props.match.url}/reports`} exact component={Reports} />
            <Route path={`${props.match.url}/reports/passes-reports`} exact component={ClassPassesReport} />
            <Route
              path={`${props.match.url}/reports/class-attendances-reports`}
              exact
              render={() => <ClassAttendancesReports locations={props.locations} history={props.history} />}
            />
            <Route
              path={`${props.match.url}/reports/attendances-reports`}
              exact
              render={() => <AttendancesReports locations={props.locations} history={props.history} />}
            />
            <Route
              path={`${props.match.url}/reports/debtors-reports`}
              exact
              render={() => <DebtorsReports locations={props.locations} history={props.history} />}
            />

            <Route
              path={`${props.match.url}/reports/payroll-reports`}
              exact
              render={() => (
                <PayrollReports locations={props.locations} history={props.history} key={document.location.href} />
              )}
            />

            {/**MEMBERSHIP PLAN ROUTES**/}
            <Route
              path={`${props.match.url}/membership-plans`}
              exact
              render={() => (
                <ManageMembershipPlans
                  plansList={props.plansList}
                  error={props.plansListError}
                  loading={props.plansListLoading}
                  match={props.match}
                />
              )}
            />
            <Route path={`${props.match.url}/membership-plans/add`} component={AddEditMembershipPlan} />
            <Route path={`${props.match.url}/membership-plans/edit`} component={AddEditMembershipPlan} />

            {/**TRAINER ROUTES**/}
            {props.userData.role === 'trainer' && (
              <Route
                path={`${props.match.url}/my-timetable`}
                render={() => <TrainersUpcomingClasses userGyms={props.userGyms} />}
              />
            )}

            {/**STAFF CALENDAR**/}
            <Route path={`${props.match.url}/staff-calendar`} exact component={StaffCalendar} />

            {/**CLASS TYPES ROUTES**/}
            <Route path={`${props.match.url}/class-history`} exact component={CombinedHistoryComponent} />
            <Route
              path={`${props.match.url}/class/:classId`}
              exact
              render={() => (
                <ClassPage
                  isAdmin={props.userData.role === 'admin'}
                  trainersList={props.trainersList}
                  clientsList={props.clientsList}
                  clientsListError={props.gymUsersListError}
                  clientsListLoading={props.gymUsersListLoading}
                />
              )}
            />

            {/**CLASS ROUTES**/}
            <Route
              path={`${props.match.url}/class-timetable`}
              exact
              render={() =>
                props.selectedGym.settings.class ? (
                  <ManageTimetable classType={CLASS.CLASS} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**PERSONAL TRAINING ROUTES**/}
            <Route
              path={`${props.match.url}/personal-training-timetable`}
              exact
              render={() =>
                props.selectedGym.settings.personalTraining ? (
                  <ManageTimetable classType={CLASS.PERSONAL_TRAINING} key={document.location.href} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**INDUCTION ROUTES**/}
            <Route
              path={`${props.match.url}/induction-timetable`}
              exact
              render={() =>
                props.selectedGym.settings.induction ? (
                  <ManageTimetable classType={CLASS.INDUCTION} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**GYM CLASS ROUTES**/}
            <Route
              path={gymLink}
              exact
              render={() =>
                props.selectedGym.settings.gymClass ? (
                  <ManageTimetable classType={CLASS.GYM_CLASS} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**GYM CLASS 2 ROUTES**/}
            <Route
              path={gymLink2}
              exact
              render={() =>
                props.selectedGym.settings.gymClass2 ? (
                  <ManageTimetable classType={CLASS.GYM_CLASS2} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**SWIM CLASS ROUTES**/}
            <Route
              path={swimLink}
              exact
              render={() =>
                props.selectedGym.settings.swimmingClass ? (
                  <ManageTimetable classType={CLASS.SWIMMING_CLASS} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**TENNIS CLASS ROUTES**/}
            <Route
              path={tennisLink}
              exact
              render={() =>
                props.selectedGym.settings.tennisClass ? (
                  <ManageTimetable classType={CLASS.TENNIS_CLASS} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**MASSAGE CLASS ROUTES**/}
            <Route
              path={massageLink}
              exact
              render={() =>
                props.selectedGym.settings.massageClass ? (
                  <ManageTimetable classType={CLASS.MASSAGE_CLASS} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />

            {/**ALL UPCOMING CLASSES FOR ALL GYMS**/}
            <Route
              path={`${props.match.url}/timetable/all`}
              exact
              render={() => <UpcomingClassesForAllGyms cancelType="upcomingClassesInAllGyms" />}
            />

            {/**VIDEO ROUTES**/}
            <Route
              path={`${props.match.url}/video-passes`}
              exact
              render={() =>
                props.selectedGym.settings.videoOnDemand ? (
                  <ManageTimetable classType={CLASS.VIDEO} />
                ) : (
                  <Redirect to={props.match.url} />
                )
              }
            />
            <Route
              path={`${props.match.url}/videos/:videoId`}
              exact
              render={({ match }) => <Viewer videoId={match.params.videoId} />}
            />

            {/**FAQ ROUTES**/}
            <Route path={`${props.match.url}/faq`} exact component={ManageFAQ} />

            {/**KIT LIST ROUTES**/}
            <Route path={`${props.match.url}/kit-list`} exact component={() => <KitList editableView={true} />} />

            <Route
              path={`${props.match.url}/videos/live-stream`}
              exact
              render={() => <LiveStreamBroadcaster userData={props.userData} />}
            />

            {/**COUPON ROUTES**/}
            <Route
              path={`${props.match.url}/coupons`}
              exact
              render={() => <ManageCoupons selectedGym={props.selectedGym} membershipPlans={props.plansList} />}
            />
          </Switch>
        </>
      );
    }

    if (props.gymDataError) {
      return <Notification message={`Error when creating admin dashboard. ${props.gymDataError}`} status="critical" />;
    }

    return <Loading />;
  };

  const renderQrReader = () => {
    if (props.globalQrReader) {
      return <AdminQrScanner isQRCodeAvailable={props.selectedGym.settings.qrCode} />;
    }
    return null;
  };
  const mainDivStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
  };

  return (
    <>
      {props.loading ||
      props.gymDataLoading ||
      !props.selectedGym ||
      props.gymUsersListLoading ||
      props.scheduledClassesListLoading ||
      props.plansListLoading ||
      props.classesTemplatesListLoading ? (
        <div style={mainDivStyles}>
          <Loading size={'xlarge'} />
        </div>
      ) : (
        <>
          <AdminTrainerSubHeader />
          <WhiteBackground>
            <div className={classes.dashboardContainer}>{renderGymDashboard()}</div>
            {renderQrReader()}
          </WhiteBackground>
        </>
      )}
    </>
  );
};

export default withUser(withAdminDashboard(AdminTrainerDashboard));
